import React from  'react';
import Buttom from './Buttom'
import './list-styles.css';

const Legacy = () => 
  <div className="listContainer">
    <ul>
    <li>2015 - Marcelo's Resume
        <Buttom title="Visit Website" src="https://www.mleite.com.br/resume2015/" />
      </li>      
    <li>2002 - Global Source
        <Buttom title="Visit Website" src="http://mleite.com.br/s/globalsource/" />
        <Buttom title="Visit Flash" src="http://mleite.com.br/s/globalsource/flash/index.html" />
      </li>      
      <li>2001 J.J. Jackson American Singer
        <Buttom title="Visit Website" src="http://mleite.com.br/s/jj/" />
      </li>
      <li>2000 - Redesign Studio BR Website 
        <Buttom title="Visit HTML" src="http://mleite.com.br/s/sbr2000/" />
      </li>
      <li>1996 - Studio BR Website 
        <Buttom title="Visit HTML" src="http://www.mleite.com.br/sbr99/home/default.html" />
        <Buttom title="Visit Flash" src="http://www.mleite.com.br/sbr99/flash/site/default.html" />        
      </li>
    </ul>
  </div>

export default Legacy